import { NavLink, useLocation } from 'react-router-dom'
import { NAV_LINKS, ROUTES } from '../../constants/NavConstants'
import style from '../../assets/style/scss/primary-navigation.scss'

const activeClass = (path, { pathname }) => (pathname === path ? 'active' : '')
const title = 'APRO: Special Order Management'

const PrimaryNavigation = () => {
  const location = useLocation()

  useEffect(() => {
    const pageTitle = Object.values(ROUTES).find(r => r.path === location.pathname)?.title
    document.title = `${pageTitle ? `${pageTitle} | ` : ''} Special Order Management | APRO`
  }, [])

  return (
    <div className="cb-local-navigation">
      <div className="container">
        <nav role="navigation" aria-label="CB Local Navigation" className="cb-desktop-navigation">
          <div className="row">
            <div className="col-xs-12">
              <div className="cb-site-name">
                <NavLink
                  className="title cb-program-name"
                  to={NAV_LINKS.dashboard}
                  style={{ margin: 0 }}
                >
                  <span>{title}</span>
                </NavLink>
              </div>
              <ul className="cb-local-menu">
                <li
                  className={`${style['nav-list-item']} ${activeClass(
                    NAV_LINKS.dashboard,
                    location
                  )}`}
                >
                  <NavLink to={NAV_LINKS.dashboard}>
                    <span>Home</span>
                  </NavLink>
                </li>
                <li
                  className={`${style['nav-list-item']} ${activeClass(NAV_LINKS.orders, location)}`}
                >
                  <NavLink to={NAV_LINKS.orders}>
                    <span>Orders</span>
                  </NavLink>
                </li>
                <li
                  className={`${style['nav-list-item']} ${activeClass(
                    NAV_LINKS.approvals,
                    location
                  )}`}
                >
                  <NavLink to={NAV_LINKS.approvals}>
                    <span>Approvals</span>
                  </NavLink>
                </li>
                <li
                  className={`${style['nav-list-item']} ${activeClass(
                    NAV_LINKS.refunds,
                    location
                  )} cb-multi`}
                >
                  <NavLink to={NAV_LINKS.refunds}>
                    <span>Refund Exams</span>
                  </NavLink>
                </li>
                <li
                  className={`${style['nav-list-item']} ${activeClass(
                    NAV_LINKS.generateapid,
                    location
                  )} cb-multi`}
                >
                  <NavLink to={NAV_LINKS.generateapid}>
                    <span>AP ID Generation</span>
                  </NavLink>
                </li>
                <li
                  className={`${style['nav-list-item']} ${activeClass(
                    NAV_LINKS.studentLocation,
                    location
                  )} cb-multi`}
                >
                  <NavLink to={NAV_LINKS.studentLocation}>
                    <span>Student Location</span>
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
  )
}

export default PrimaryNavigation
